import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EmptyError, firstValueFrom } from "rxjs";
import { environment } from "../../../environments/environment";
import { IContributionsQuoteDTO } from "../models/IContributionsQuote";
import { IContributionsQuoteFormDTO } from "../models/IContributionsQuoteForm";

const hostUrl = environment.host;
@Injectable()
export class SocialHousingService {
  public currentform?: IContributionsQuoteFormDTO;
  public lastSearchResult?: IContributionsQuoteDTO;

  constructor(private http: HttpClient) {}

  public calculateSocialHousing(
    form: IContributionsQuoteFormDTO = null,
  ): Promise<IContributionsQuoteDTO> {
    if (form != null) {
      this.currentform = form;
    }

    if (this.currentform) {
      return firstValueFrom(
        this.http.post<IContributionsQuoteDTO>(
          `${hostUrl}quotes`,
          this.currentform,
        ),
      ).catch((error) => {
        throw error;
      });
    } else {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw EmptyError;
    }
  }
}
